import clsx from 'clsx';
import { useRef } from 'react';
import { Typography, Icon, Tooltip, BADGE_LABEL_COLORS } from '@hevoio/hevo-ui-toolkit';
import styles from './AppbarSupportCTA.module.scss';
import OverlayBadgeLabel from '../../../../badge/components/label/OverlayBadge';
import useAnalyticsTracker from '../../../../analytics/hooks/useAnalyticsTracker';

interface AppbarSupportCTAProps {
  iconName?: string;
  label: string;
  trackingEvent: string;
  supportPersonImageURL?: string;
  showOnCallSupportIndicator: boolean;
  badgeContent: string;
  onClick?: () => void;
  expanded?: boolean;
  disableTooltip?: boolean;
}

export function AppbarSupportCTA({
  iconName,
  label,
  trackingEvent,
  supportPersonImageURL,
  showOnCallSupportIndicator,
  badgeContent,
  onClick,
  expanded = false,
  disableTooltip = false
}: AppbarSupportCTAProps) {
  const ref = useRef<any>();
  const analyticsTracker = useAnalyticsTracker();

  const handleClick = () => {
    analyticsTracker.eventTrack({ action: trackingEvent });
    if (typeof onClick !== 'undefined') {
      onClick();
    }
  };

  // Shared icon element used in both collapsed and expanded
  const iconEl = (
    <OverlayBadgeLabel
      content={badgeContent}
      color={BADGE_LABEL_COLORS.ERROR}
      direction={{ vertical: 'top', horizontal: 'right' }}
    >
      <div
        className={clsx(
          styles.appbarCtaIconFlat,
          showOnCallSupportIndicator && styles.supportStatusDotFlat
        )}
      >
        {iconName && <Icon name={iconName} className={styles.appbarCtaIconFlatIcon} />}
        {supportPersonImageURL && (
          <img src={supportPersonImageURL} alt='' className={styles.appbarCtaAvatarFlat} />
        )}
      </div>
    </OverlayBadgeLabel>
  );

  return (
    <Tooltip
      dataId='appbar-support-cta-tooltip'
      title={label}
      placement='right'
      disabled={expanded || disableTooltip}
    >
      <div
        data-id='appbar-support-cta'
        onClick={handleClick}
        ref={ref}
        className={expanded ? styles.appbarCtaContainerExpanded : styles.appbarCtaContainer}
      >
        <div className={styles.iconWrapper}>{iconEl}</div>
        <div className={clsx(styles.labelWrap, expanded && styles.labelWrapVisible)}>
          <Typography level='label-small' color='soft-400' hoverColor='light' focusColor='light'>
            {label}
          </Typography>
        </div>
      </div>
    </Tooltip>
  );
}
